import { useFormik } from "formik";
import { Categoria } from "../../types/Categoria/Categoria";
import { Alert, Box, Button, FormControl, Grid, TextField } from "@mui/material";
import { Iconify } from "../../common/iconify";
import CategoriasService from "../../services/CategoriasService";
import { useState } from "react";
import { validationCategoria } from "../validationsForm/ValidationCategoria";

interface Props {
    categoria: Categoria;
    onResponse?: (dataRespuesta: any) => void
}

export const CategoriaForm: React.FC<Props> = ({ categoria, onResponse }) => {
    const [textoError, setTextoError] = useState('');

    const formik = useFormik<Categoria>({
        initialValues: {
            ...categoria,
            bdEstadoRegistro: true,
        },
        validationSchema: validationCategoria,
        onSubmit: (values) => {
            if(values.idCategoria === 0){
                Guardar(values)
            }else{
                Editar(values)
            }
            
        }
    });

    async function Guardar(categoria: Categoria){
        setTextoError('');
        await CategoriasService.CrearCategoria(categoria)
        .then(data => {
            if(data.status.isSuccessfully){
                if(onResponse){
                    onResponse(data.statusCode)
                }
            }else{
                setTextoError('No pudo guardarse')
                console.error(data.status)
            }
        }).catch(error => {
            setTextoError('No pudo guardarse')
            console.error(error)
        })
    }

    async function Editar(categoria: Categoria){
        setTextoError('');
        await CategoriasService.EditarCategoria(categoria)
        .then(data => {
            if(data.status.isSuccessfully){
                if(onResponse){
                    onResponse(data.statusCode)
                }
            }else{
                setTextoError('No pudo guardarse')
                console.error(data.status)
            }
        }).catch(error => {
            setTextoError('No pudo guardarse')
            console.error(error)
        })
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container direction={'row'} spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.txNombreCategoria && formik.touched.txNombreCategoria)}>
                        <TextField
                            fullWidth
                            id="txNombreCategoria"
                            name="txNombreCategoria"
                            label="Nombre"
                            value={formik.values.txNombreCategoria}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txNombreCategoria && Boolean(formik.errors.txNombreCategoria)}
                            sx={{ marginBottom: '20px', width: '100%' }}
                        />
                        {formik.touched.txNombreCategoria && formik.errors.txNombreCategoria && (
                            <Alert severity="error">{formik.errors.txNombreCategoria}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.txtDescripcion && formik.touched.txtDescripcion)}>
                        <TextField
                            multiline
                            rows={2}
                            id="txtDescripcion"
                            name="txtDescripcion"
                            label="Descripción"
                            value={formik.values.txtDescripcion}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txtDescripcion && Boolean(formik.errors.txtDescripcion)}
                            sx={{ marginBottom: '20px', width: '100%' }}
                        />
                        {formik.touched.txtDescripcion && formik.errors.txtDescripcion && (
                            <Alert severity="error">{formik.errors.txtDescripcion}</Alert>
                        )}
                    </FormControl>
                </Grid>
                {textoError !== '' ? <Alert severity="error">{textoError}</Alert> : <></>}
                <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" justifyContent="flex-end">
                        <Button type="submit" size="large" variant="contained" color='primary' endIcon={<Iconify icon={"material-symbols:save-outline"} />}>
                            Guardar
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
}